module.exports = __webpack_public_path__ + "img/transpond.7ad8a0eb.png";